<div class="container">
  <app-drawer-workorder-title
    title="{{ drawerTitle }}"
    [externalId]="workOrder.externalId"
    [clientName]="workOrder.clientName"
  ></app-drawer-workorder-title>

  <div>
    <div
      class="add-visit"
      *ngIf="(visitsView$ | async) === EmployeeVisitsView.List"
    >
      <button mat-button (click)="openCreateEmployeeVisitsWizard()">
        {{ "workorder.employee-visits.create-visit" | translate }}
        <mat-icon>add</mat-icon>
      </button>
    </div>

    <ul *ngIf="(visitsView$ | async) === EmployeeVisitsView.List">
      <li
        tabindex="0"
        *ngFor="let day of employeeVisitsByDay | async"
        (click)="openEditEmployeeVisitsWizard(day.employeeVisitsByDay)"
        (keyup.enter)="openEditEmployeeVisitsWizard(day.employeeVisitsByDay!)"
      >
        <div class="team-info">
          <p class="date">
            {{ day.day | localizedDate : "dd MMMM, yyyy" }}
          </p>
          <p class="employeeName">{{ day.employeeNames }}</p>
        </div>
        <button
          mat-icon-button
          class="icon"
          (click)="$event.stopPropagation(); deleteEmployeeVisits(day)"
        >
          <mat-icon>delete</mat-icon>
        </button>
      </li>

      <p class="no-visits" *ngIf="(employeeVisitsByDay$ | async)?.length === 0">
        {{ "workorder.employee-visits.no-visits" | translate }}
      </p>
    </ul>

    <app-workorder-create-employee-visits-wizard
      #createEmployeeVisitsWizard
      *ngIf="(visitsView$ | async) === EmployeeVisitsView.CreateWizard"
      [workOrder]="workOrder"
      (employeeVisitsViewChange)="changeEmployeeVisitsView($event)"
      (enableSaveButton)="enableSaveButton($event)"
    >
    </app-workorder-create-employee-visits-wizard>

    <app-workorder-edit-employee-visits-wizard
      #editEmployeeVisitsWizard
      *ngIf="(visitsView$ | async) === EmployeeVisitsView.EditWizard"
      [workOrderId]="workOrder.id"
      [employeeVisits]="employeeVisitsToEdit"
      (employeeVisitsViewChange)="changeEmployeeVisitsView($event)"
    >
    </app-workorder-edit-employee-visits-wizard>

    <app-workorder-signature-wizard
      #signatureWizard
      *ngIf="(visitsView$ | async) === EmployeeVisitsView.SignatureWizard"
      [workOrderId]="workOrder.id"
      [employeeVisitsByDay]="employeeVisitsByDay | async"
      (enableSaveButton)="enableSaveButton($event)"
      (employeeVisitsViewChange)="changeEmployeeVisitsView($event)"
    ></app-workorder-signature-wizard>
  </div>

  <app-drawer-workorder-actions
    class="buttons"
    [confirmButtonName]="confirmButtonName"
    (clickConfirmButtonEvent)="confirm()"
    [confirmButtonIsEnable]="saveButtonIsEnable"
    (clickCancelButtonEvent)="cancel()"
  ></app-drawer-workorder-actions>
</div>
